import { DataService } from '../../services/data.service';
import { observable, action, } from 'mobx';
import { Injectable } from '@angular/core';
import { pushToArray, pushToObject, pushStringArray, removeStingArray } from 'src/app/services/convert.service';
import { APPS, COLLECTION_NAME } from 'src/app/dummy/app';
import { ITrending } from 'src/app/interfaces/book-store';
import { ITutor, IClassroom, IClassSchedule } from 'src/app/interfaces/enrollment';

@Injectable()
export class EnrollmentStore {
    @observable data: any[] = [];
    @observable process: boolean = false;
    @observable loading: boolean = true;
    @observable empty: boolean = false;
    @observable lastVisible: any = null;
    @observable fetching: boolean = false;

    constructor(private ds: DataService) { }

    @action
    async fetchListArray(collectionName, orderBy) {
        const docs = await this.ds.listRef(collectionName, orderBy).get().toPromise();
        return pushToArray(docs);
    }

    @action
    async fetchCollection(collectionName, orderBy) {
        const docs = await this.ds.firestoreRef().collection(collectionName, ref => ref.orderBy(orderBy)).get().toPromise();
        return pushToArray(docs);
    }

    @action
    async fetchActivityType(key) {
        const docs = await this.ds.firestoreRef().collection(COLLECTION_NAME.ACTIVITY_TYPE).doc(key).get().toPromise();
        return pushToObject(docs);
    }

    @action
    fetchDataList(collectionName, orderBy, callback) {
        this.ds.firestoreRef().collection(collectionName, ref => ref.orderBy(orderBy)).valueChanges().subscribe(docs => {
            callback(docs)
        })
    }


    @action
    fetchList(collectionName, orderBy, callback) {
        this.ds.listRef(collectionName, orderBy).valueChanges().subscribe(docs => {
            callback(docs)
        })
    }

    @action
    fetchActivityByModule(moduleKey, activityTypeKey, organizationKey, callback) {
        this.loading = true;
        this.ds.activityByModuleRef(moduleKey, activityTypeKey, organizationKey).valueChanges().subscribe(docs => {
            this.loading = false;
            callback(docs)
        })
    }


    @action
    async fetchActivity(moduleKey, displayStatus, organizationKey: string) {
        this.lastVisible = null;
        this.loading = true;
        this.ds.activityRef(this.lastVisible, moduleKey, displayStatus, organizationKey).valueChanges().subscribe(docs => {
            this.data = docs
            this.empty = docs.length === 0;
            this.loading = false;
            if (docs.length > 0 && docs.length >= APPS.SIZE) {
                this.lastVisible = docs[docs.length - 1];
            } else {
                this.lastVisible = null;
            }
        })
    }


    @action
    async fetchData(collectionName, displayStatus: any) {
        this.lastVisible = null;
        this.loading = true;
        const docs = pushToArray(await this.ds.bookstoreRef(collectionName, this.lastVisible, displayStatus).get().toPromise());
        this.data = docs
        this.empty = docs.length === 0;
        this.loading = false;
        if (docs.length > 0 && docs.length >= APPS.SIZE) {
            this.lastVisible = docs[docs.length - 1];
        } else {
            this.lastVisible = null;
        }
    }

    @action
    async fetchMore(collectionName, displayStatus: any) {
        if (this.fetching || this.lastVisible === null || this.loading) { return; }
        this.fetching = true;
        const docsData = await this.ds.bookstoreRef(collectionName, this.lastVisible, displayStatus).get().toPromise();
        const docs = pushToArray(docsData);
        if (docs.length > 0 && docs.length >= APPS.SIZE) {
            this.lastVisible = docs[docs.length - 1];
        } else {
            this.lastVisible = null;
        }
        this.data = this.data.slice().concat(docs);
        this.fetching = false;
    }

    @action
    fetchSelectedData(collectionName, key: any, callback) {
        this.ds.firestoreRef().collection(collectionName).doc(key).valueChanges().subscribe(doc => {
            callback(doc)
        })
    }


    @action
    fetchClass() {
        this.loading = true;
        this.ds.classRoomRef().valueChanges().subscribe(docs => {
            this.data = docs;
            this.empty = docs.length === 0;
            this.loading = false;
        })
    }


    @action
    addTutor(collectionName, item: ITutor, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const ref = this.ds.batchCollectionRef().collection(collectionName).doc(item.key);
        const studentRef = this.ds.batchCollectionRef().collection(COLLECTION_NAME.STUDENTS).doc(item.key);
        batch.set(ref, item);
        batch.set(studentRef, {
            ...item,
            displayName: item.fullname,
            phoneNumber: `${item.phone}`,
            isTeacher: true,
        })
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    save(item: IClassroom, callback) {
        this.process = true;
        this.ds.classRoomRef().doc(item.key).set(item).then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    addItem(collectionName, item: ITrending, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const ref = this.ds.batchCollectionRef().collection(collectionName).doc(item.key);
        batch.set(ref, item);
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

}
